import { THRESHOLDS } from "@/config/thresholds";
// 機械の上限閾値温度に応じて、Circle の色を変化させる
export function getCircleColor(thHigh: number) {
  if (thHigh >= THRESHOLDS[0] && thHigh <= THRESHOLDS[1]) return 0;
  if (thHigh >= THRESHOLDS[1] && thHigh <= THRESHOLDS[2]) return 1;
  if (thHigh >= THRESHOLDS[2] && thHigh <= THRESHOLDS[3]) return 2;

  return 3;
}
